import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_atomic_crm_dark.svg";
import lightModeLogo from "./logos/logo_atomic_crm_light.svg";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "USD";

export const defaultTitle = "Precision Exteriors CRM";

export const defaultCompanySectors = [
  { value: "communication-services", label: "Communication Services" },
  { value: "consumer-discretionary", label: "Consumer Discretionary" },
  { value: "consumer-staples", label: "Consumer Staples" },
  { value: "energy", label: "Energy" },
  { value: "financials", label: "Financials" },
  { value: "health-care", label: "Health Care" },
  { value: "industrials", label: "Industrials" },
  { value: "information-technology", label: "Information Technology" },
  { value: "materials", label: "Materials" },
  { value: "real-estate", label: "Real Estate" },
  { value: "utilities", label: "Utilities" },
];

export const defaultProjectStages = [
  { value: "opportunity", label: "Opportunity" },
  { value: "estimate-sent", label: "Estimate Sent" },
  { value: "in-progress", label: "In Progress" },
  { value: "closed-lost", label: "Closed Lost" },
  { value: "on-hold", label: "On Hold" },
  {
    value: "completed-pending-payment",
    label: "Completed Pending Payment",
  },
  { value: "completed", label: "Completed" },
  { value: "referral-mining", label: "Referral Mining" },
];

export const defaultProjectPipelineStatuses = ["closed-lost", "completed"];

export const defaultProjectTypes = [
  { value: "roof", label: "Roof" },
  { value: "roof-replacement", label: "Roof Replacement" },
  { value: "roof-repair", label: "Roof Repair" },
  { value: "solar-r-and-r", label: "Solar Removal & Reinstall" },
  { value: "gutter-replacement", label: "Gutter Replacement" },
  { value: "gutter-repair", label: "Gutter Repair" },
  { value: "siding", label: "Siding" },
  { value: "other", label: "Other" },
];

// Legacy aliases keep existing integrations and stored config readable.
export const defaultDealStages = defaultProjectStages;
export const defaultDealPipelineStatuses = defaultProjectPipelineStatuses;
export const defaultDealCategories = defaultProjectTypes;

export const defaultNoteStatuses = [
  { value: "cold", label: "Cold", color: "#7dbde8" },
  { value: "warm", label: "Warm", color: "#e8cb7d" },
  { value: "hot", label: "Hot", color: "#e88b7d" },
  { value: "in-contract", label: "In Contract", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "email", label: "Email" },
  { value: "demo", label: "Demo" },
  { value: "lunch", label: "Lunch" },
  { value: "meeting", label: "Meeting" },
  { value: "follow-up", label: "Follow-up" },
  { value: "thank-you", label: "Thank you" },
  { value: "ship", label: "Ship" },
  { value: "call", label: "Call" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  projectTypes: defaultProjectTypes,
  projectPipelineStatuses: defaultProjectPipelineStatuses,
  projectStages: defaultProjectStages,
  dealCategories: defaultProjectTypes,
  dealPipelineStatuses: defaultProjectPipelineStatuses,
  dealStages: defaultProjectStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
